<!-- 提示富文本配置 -->
<template>
  <basic-container v-loading="loading">
    <el-row class="bx-xs-gray bt-xs-gray">
      <el-form :model="form" :rules="{}" ref="form">
        <el-form-item label="" label-width="0px" class="el-form-style">
          <avue-ueditor v-model="form.TEXTAREA " :options="option"></avue-ueditor>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row class="bl-xs-gray bb-xs-gray">
      <el-col span="24" class="br-xs-gray bt-xs-gray">
        <el-upload style="width: 100%" ref="upload" action :on-preview="(file,index) => {handlePreview(file, index)}" :on-remove="handleRemove" :auto-upload="false" :on-change="(file, fileList) => { onChange(file, fileList, 0); }" multiple :file-list="fileList">
          <el-button icon="el-icon-upload" style="width: 100%">选择附件</el-button>
        </el-upload>
      </el-col>
    </el-row>
    <el-row class="bx-xs-gray bb-xs-gray ds-fx justify-content-center">
      <el-button type="primary" @click="save" size="mini" :loading="loading">确 定</el-button>
      <el-button @click="cancel" size="mini" :loading="loading">取 消</el-button>
    </el-row>
  </basic-container>
</template>
<script>
import {addShow,updateShow} from "@/api/table/table";
import {usualUploadFile,removeFile} from "@/api/system/file";
import {getColProperty} from "@/api/system/param"
export default {
  components: {},
  data() {
    return {
      form:{},
      fileList: [], //上传的文件列表
      option: {
        //普通图片上传
        action: "/api/blade-fileserver/api/fileserver/uploadFileByFwb?runId="+this.$route.query.runId,
        props: {
          res: "data",
          url: "url",
        },
        customConfig: {
          // height: 500,
          // menus: [
          //   "head", // 标题
          //   "bold", // 粗体
          //   "fontSize", // 字号
          //   "fontName", // 字体
          //   "italic", // 斜体
          //   "underline", // 下划线
          //   "strikeThrough", // 删除线
          //   "indent",//缩进
          //   "foreColor", // 文字颜色
          //   "backColor", // 背景颜色
          //   "link", // 插入链接
          //   "list", // 列表
          //   "justify", // 对齐方式
          //   "quote", // 引用
          //   "emoticon", // 表情
          //   "image", // 插入图片
          //   "table", // 表格
          //   "undo", // 撤销
          //   "redo" // 重复
          // ],
          excludeMenus: [
            "video",//视频
            "code", // 不管用
            "html"  // 不管用
          ]
        }, //wangEditor编辑的配置
      },
      loading: false,
      updateFlag: false,
      firstEnter: true,
      fileFlag: false
    };
  },
  computed: {},
  watch: {
  },
  methods: {
    // 附件改变
    onChange(file, fileList, type) {
      this.fileList = fileList;
      this.fileFlag = true
    },
    //删除
    handleRemove(file, fileList) {
      if(file.ID){
        removeFile(
          this.$qs.stringify({
            businessType: "501",
            businessId: "",
            fileId: file.ID,
            runId: this.$route.query.runId,
          })
        ).then(res => {
          this.$message.success("删除成功!");
        });
      }
      this.fileList = fileList;
    },
    // 点击确定
    async save(){
      this.loading = true
      let obj = {
        data:this.form,
        runId:this.$route.query.runId,
        dwId:"340"
      }
      try {
        let res = ''
        if(this.form.ID){
          res = await updateShow(obj)
        }else{
          obj.data.DWID = this.$route.query.dwId
          obj.data.COLID = this.$route.query.colId
          obj.data['COL_NAME'] = this.$route.query.colName
          res = await addShow(obj)
        }
        if(this.fileList.length > 0 && this.fileFlag){
          await this.uploadFile(this.fileList,res.data.data);
        }
        this.loading = false
        this.$message.success("操作成功!");
        this.cancel()
      } catch (error) {
        this.loading = false
      }
    },
    // 附件上传
    async uploadFile(fileList,ID){
      if(fileList.length>0){
        this.loading=true;
        let fileData = new FormData();
        var params = {
          businessType:501,
          businessId:parseInt(ID)
        }
        let newArr = [],oldArr = [];
        fileList.forEach((file,index)=>{
          if(!file.ID){
            fileData.append("files",file.raw);
            newArr.push({
              SHOW_NAME: this.removeSuffix(file.name)
            })
          }else{
            oldArr.push({
              SHOW_NAME: file.SHOW_NAME,
              ID: file.ID
            })
          }
        })
        for (const key in params) {
          const element = JSON.stringify(params[key]);
          fileData.append(key,element);
        }
        fileData.append("newProps", JSON.stringify(newArr));
        fileData.append("oldProps", JSON.stringify(oldArr));
        fileData.append('runId',this.$route.query.runId);
        await usualUploadFile(fileData)
      }
    },
    // 删除后缀
    removeSuffix(name) {
      let list = name.split(".");
      let showName = [];
      for (let index = 0; index < list.length - 1; index++) {
        const element = list[index];
        showName.push(element);
      }
      return showName.join(".");
    },
    //关闭
    cancel() {
      this.$store.commit("DEL_TAG", { value: this.$route.fullPath });
      this.$router.go(-1);
    },
    async onLoad(){
      let {data:{data:{data:res}}} = await getColProperty({colid:this.$route.query.colId})
      console.log(res)
      if(res.ID){
        if(res.fileinfo.records.length > 0){
          let resFile = res.fileinfo.records
          resFile.map(item => {
            this.fileList.push({
              name:item.SHOW_NAME,
              ...item
            })
          })
        }
        delete res.fileinfo
        this.form = {...res}
      }else{
        this.form = {}
        this.fileList = []
      }
    }
  },
  created() {},
  mounted() {
    this.onLoad()
  },
  activated() {
    if(this.firstEnter){
      this.firstEnter = false
    }else{
      this.onLoad()
    }
  }
};
</script>
<style lang='scss' scoped>
  /deep/.el-col{
    margin-bottom: 0px !important
  }
  /deep/.el-upload{
    width: 100% !important;
  }
  /deep/.el-form-item{
    margin-bottom: 0px !important
  }
  .el-form-style /deep/.el-form-item__label{
    top: 46% !important;
    position: absolute !important;
  }
  /deep/.w-e-text-container{
    height: 60vh !important;
  }
  /deep/.wangEditor_html{
    display: none !important;
  }
</style>